import { render, staticRenderFns } from "./AutopsyReport.vue?vue&type=template&id=8128167a&"
import script from "./AutopsyReport.vue?vue&type=script&lang=js&"
export * from "./AutopsyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports